<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Transaction Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                v-bind:search="search"
                :items-per-page-options="itemsPerPage"
                v-bind:options.sync="pagination"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', 'tranTypes')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', 'tranTypes')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    param: String,
    boolRefresh: Boolean
  },
  data() {
    return {
      headers: [
        { text: 'Transaction Type', value: 'tranTypes' },
        { text: 'Description', value: 'tranTypesDesc' }
      ],
      tranTypesList: [
        { label: 'New', value: 'N' },
        { label: 'Cancellations', value: 'C' },
        { label: 'Endorsements', value: 'E' },
        { label: 'Renewals', value: 'R' },
        { label: 'Transfers', value: 'T' }
      ],
      pagination: {
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  created() {
    this.doInit()
  },
  watch: {
    boolRefresh: function () {
      this.doInit()
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      this.items = []
      this.selectedItems = []
      const data = this.tranTypesList
      if (data) {
        data.map((param) => {
          const convertList = {
            key: param.value,
            tranTypes: param.value,
            tranTypesDesc: param.label
          }
          if (this.checkedItems.includes(param.value)) {
            const selectedInsuredList = {
              key: param.value,
              tranTypes: param.value,
              tranTypesDesc: param.label
            }
            this.selectedItems.push(selectedInsuredList)
          }
          this.items.push(convertList)
        })
      }
      if (this.checkedItems.toString() === 'All') {
        this.doReset()
        this.toggleAll()
      } else {
        this.toggleSelected()
      }
      this.loading = false
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>
